module.exports = __webpack_public_path__ + "static/media/canaryLogo-V2-img.92f937a6.png";